module.exports = __webpack_public_path__ + "img/f9db108.png";